import { EnvironmentProviders, Provider, importProvidersFrom } from '@angular/core';

import { I18NextModule } from 'angular-i18next';

import { I18N_INIT_PROVIDERS } from './i18n-init.providers';
import { TRANSLATION_PROVIDERS } from './translation.providers';

export const APP_TRANSLATION_PROVIDERS: Array<Provider | EnvironmentProviders> = [
  importProvidersFrom(I18NextModule.forRoot()),
  I18N_INIT_PROVIDERS,
  TRANSLATION_PROVIDERS
];
